import { atom } from 'recoil';

import { IInvestedAssetsNormalized } from './types';

export const isExportingPdfForCustomersAssets = atom({
  key: 'isExportingPdfForCustomersAssets',
  default: false,
});

export const customersAssetsDateSelected = atom<Date | undefined>({
  key: 'customersAssetsDateSelected',
  default: undefined,
});

export const customerAssetProductSelected = atom<
  Record<string, IInvestedAssetsNormalized | undefined>
>({
  key: 'customerAssetProductSelected',
  default: {},
});
